require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ens-de-lyon-biotech-et-ing-chim-2-5-2-5.json") })
        }
      }, "path---ens-de-lyon-biotech-et-ing-chim-2-5-2-5");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ens-de-lyon-biotech-et-ing-chim-2-5-2-5!./.cache/json/ens-de-lyon-biotech-et-ing-chim-2-5-2-5.json
// module id = 409
// module chunks = 231608221292675